"use strict";

var React = require('react');

var compose = require('../hoc/compose');

var displayNames = require('./displayNames');

var _Symbol = function _Symbol(props) {
  return React.createElement('span', {
    className: props.getClassName('symbol')
  }, props.children);
};

_Symbol.displayName = displayNames.Symbol;
_Symbol.propTypes = {};
module.exports = compose(_Symbol);